import { create } from "zustand";
import { FILTER_VALUES } from "@/constants/filters";
import { DEFAULT_SHARED_TIME_RANGE } from "@/constants/timeRange";
const DEFAULT_FILTERS = {
    selectedPeriod: DEFAULT_SHARED_TIME_RANGE,
    selectedApiKey: FILTER_VALUES.ALL
};
const useUtilizationDeepDiveStoreBase = create((set)=>({
        selectedContractId: "",
        filters: {
            ...DEFAULT_FILTERS
        },
        actions: {
            setSelectedContractId: (selectedContractId)=>set((state)=>({
                        selectedContractId,
                        filters: {
                            ...state.filters,
                            selectedApiKey: FILTER_VALUES.ALL
                        }
                    })),
            setSelectedPeriod: (selectedPeriod)=>set((state)=>({
                        filters: {
                            ...state.filters,
                            selectedPeriod
                        }
                    })),
            setSelectedApiKey: (selectedApiKey)=>set((state)=>({
                        filters: {
                            ...state.filters,
                            selectedApiKey
                        }
                    })),
            resetFilters: ()=>set({
                    filters: {
                        ...DEFAULT_FILTERS
                    }
                })
        }
    }));
export default function useUtilizationDeepDiveStore() {
    const selectedContractId = useUtilizationDeepDiveStoreBase((state)=>state.selectedContractId);
    const filters = useUtilizationDeepDiveStoreBase((state)=>state.filters);
    const actions = useUtilizationDeepDiveStoreBase((state)=>state.actions);
    return {
        selectedContractId,
        filters,
        ...actions
    };
}
export const utilizationDeepDiveStore = useUtilizationDeepDiveStoreBase;
